import { useState } from "react";
import TaskHeader from "components/task/header/TaskHeader";
import { Box, Stack } from "@mui/joy";
import { ProgramContentType } from "data/BlockComponent";
import { useRecoilValue } from "recoil";
import { useQuery } from "@tanstack/react-query";
import { userAtom } from "recoil/userAtom";
import {
  MEDITATION_RECORD_DOMAIN,
  MEDITATION_RECORD_LIST_ENDPOINT,
  meditationRecordApi,
  MeditationRecordType,
} from "api/meditationRecordApi";
import useIsInappWebview from "hooks/useIsInappWebview";
import { theme } from "styles/theme";
import MeditationRecordListForMobile from "./MeditationRecordListForMobile";

export default function MeditationRecordMobileListPage() {
  const user = useRecoilValue(userAtom);

  const isInappWebview = useIsInappWebview();

  const [data, setData] = useState<ProgramContentType[] | undefined>();

  const [meditationRecordList, setMeditationRecordList] = useState<
    MeditationRecordType[] | undefined
  >();

  const [currentMeditationRecord, setCurrentMeditationRecord] = useState<
    MeditationRecordType | undefined
  >();

  useQuery(
    [MEDITATION_RECORD_DOMAIN, MEDITATION_RECORD_LIST_ENDPOINT, user?.userId!!],
    () => meditationRecordApi.getList(user?.userId!!),
    {
      enabled: !!user?.userId,
      onSuccess: (data) => {
        setMeditationRecordList((prevList) => {
          return data.result?.map((each) => ({
            ...each,
            shouldBeDone: each?.isDone
              ? false
              : prevList?.find(
                  (element) =>
                    element.meditationRecordKey === each.meditationRecordKey
                )?.shouldBeDone,
          }));
        });
      },
    }
  );

  return (
    <Stack
      direction="column"
      sx={{
        height: "100%",
        width: "100%",
        backgroundColor: theme.vars.palette.Background.Level1,
      }}
    >
      <Box
        sx={{
          flex: "none",
          zIndex: 100,
        }}
      >
        <TaskHeader
          key={`meditationRecords:${user?.userId}`}
          taskKey={`meditationRecords:${user?.userId}`}
          title={"명상훈련지"}
          contentData={data}
          setContentData={setData}
        />
      </Box>
      <Stack
        sx={{
          flex: 1,
          overflow: "hidden",
          position: "relative",
          "::after": {
            content: '""',
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: "env(safe-area-inset-bottom, 0px)",
            background: `linear-gradient(180deg, rgba(246, 249, 250, 0) 0%, ${theme.vars.palette.Background.Level1} 20%)`,
            pointerEvents: "none",
          },
        }}
      >
        <MeditationRecordListForMobile
          meditationRecordList={meditationRecordList}
          currentMeditationRecord={currentMeditationRecord}
          setCurrentMeditationRecord={setCurrentMeditationRecord}
        />
      </Stack>
    </Stack>
  );
}
